import { Modal } from 'antd';
import React from 'react';
import { IoMdCloseCircleOutline } from 'react-icons/io';

const UpdateUserModal = ({ updateModalOpen, setUpdateModalOpen }) => {
  console.log('yes');
  return (
    <Modal
      isOpen={updateModalOpen}
      onRequestClose={() => setUpdateModalOpen(false)}
      contentLabel="Example Modal"
      style={{
        content: {
          width: '45%',
          height: '50%',
          margin: 'auto',
          borderRadius: '20px',
          padding: 0,
        },
        overlay: {
          backgroundColor: 'rgba(0, 0, 0, 0.7)',
        },
      }}
    >
      <div className="flex justify-between  mx-5 my-3">
        <h1 className="text-2xl font-semibold">User Details</h1>
        <button onClick={() => setUpdateModalOpen(false)}>
          <IoMdCloseCircleOutline size={20} />
        </button>
      </div>
      <hr />

      <div className="flex justify-between items-center mx-5 my-5 gap-5">
        <div className="">
          <div>
            <p>User Name</p>
            <input
              className="p-2 w-full bg-purple-100 border rounded-lg text-sm outline-none  my-1"
              type="text"
              id="search"
              // value={`${selectUser.firstName} ${selectUser.lastName}`}
              placeholder="Enter Name"
              readOnly
            />
          </div>
          <div className="flex justify-between gap-5 my-3">
            <div>
              <p>Email</p>
              <input
                className="p-2 w-44 border bg-gray-100 rounded-lg text-sm outline-none  my-1"
                type="text"
                disabled="true"
                id="search"
                placeholder="Enter Email"
                // value={selectUser.email}
                readOnly
              />
            </div>
            <div>
              <p>Password</p>
              <div className="flex items-center border bg-purple-100 rounded-lg text-sm outline-none  my-1 pr-3">
                <input
                  // type={showPassword ? "text" : "password"}
                  className="p-2 w-40 bg-transparent outline-none"
                  id="search"
                  placeholder="Enter Password"
                  // value={selectUser.password}
                  readOnly
                />
                {/* {showPassword ? (
                      <AiFillEye
                        size={20}
                        color="red"
                        style={{ cursor: "pointer" }}
                        onClick={togglePasswordVisibility}
                      />
                    ) : (
                      <AiFillEyeInvisible
                        size={20}
                        color="red"
                        style={{ cursor: "pointer" }}
                        onClick={togglePasswordVisibility}
                      />
                    )} */}
              </div>
            </div>
          </div>
          <div>
            <p>Phone Number</p>
            <input
              className="p-2 w-full bg-purple-100 border rounded-lg text-sm outline-none  my-1"
              type="number"
              id="search"
              placeholder="555-555-5555"
              // value={selectUser.phone}
              readOnly
            />
          </div>

          <div>
            <p>User Roles</p>
            <input
              className="p-2 w-full bg-gray-100 border rounded-lg text-sm outline-none  my-1"
              type="text"
              id="search"
              placeholder="Editor"
              readOnly
              disabled="true"
              // value={selectUser._roles.map((role) => role.role.name)}
            />
          </div>
        </div>
        {/* <div className=" w-full space-y-3"> */}
        {/* <div>
                <p>User Assigned By</p>
                <input
                  className="p-2 w-full bg-purple-100 border rounded-lg text-sm outline-none  my-1"
                  type="text"
                  id="search"
                  placeholder="Organization Name"
                />
              </div> */}
        {/* <div>
                <p>User Assigned Procedure</p>
                <select
                  className="p-2 w-full bg-purple-100 border rounded-lg text-sm outline-none my-1"
                  id="userAssignedProcedure"
                >
                  <option value="Procedure1">Procedure 1</option>
                  <option value="Procedure2">Procedure 2</option>
                  <option value="Procedure2">Procedure 3</option>
                 
                </select>
              </div> */}
        {/* </div> */}
      </div>

      <div className=" flex justify-end mx-5 my-3 gap-3">
        <button
          // onClick={closeModal}
          className="border border-red-500 bg-red-500 text-white p-1 px-5 rounded-lg"
        >
          Close
        </button>
      </div>
    </Modal>
  );
};

export default UpdateUserModal;
